import React, { useState, useEffect } from 'react';
import { useUser } from '../../context/UserContext';
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import { useNavigate } from 'react-router-dom';
import Table from '../UI/Table';
import Button from '../UI/Button';
import Modal from '../UI/Modal';
import ProductEditForm from './ProductEditForm';
import QRCodeBox from '../UI/QRCodeBox';

const ProductsList = () => {
    const { logout } = useUser();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/products`,
                {},
                logout
            );
            const data = await response.json();
            setProducts(data);
        } catch (err) {
            setError('Ошибка загрузки продуктов');
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (product) => {
        setSelectedProduct(product);
        setShowEditModal(true);
    };

    const handleDelete = async (productId) => {
        if (window.confirm('Вы уверены, что хотите удалить этот продукт?')) {
            try {
                await fetchWithAuth(
                    `${process.env.REACT_APP_API_URL}/products/${productId}`,
                    {
                        method: 'DELETE',
                    },
                    logout
                );
                fetchProducts();
            } catch (err) {
                setError('Ошибка удаления продукта');
            }
        }
    };

    const columns = [
        { header: 'Артикул', accessor: 'article' },
        { header: 'Название', accessor: 'name' },
        { header: 'Описание', accessor: 'description' },
        { header: 'QR код', accessor: 'qrCode' },
        { header: 'Действия', accessor: 'actions' }
    ];
    const data = products.map(product => ({
        article: product.article,
        name: product.name,
        description: product.description,
        qrCode: <QRCodeBox
            qrCodePath={product.qrCodePath}
            type="product"
            objectId={product._id}
            withActions 
        />,
        actions: (
            <div className="flex gap-2">
                <Button
                    onClick={() => navigate(`/products/${product._id}`)}
                    variant="edit"
                >
                    Подробнее
                </Button>
                <Button
                    onClick={() => handleEdit(product)}
                    variant="edit"
                >
                    Редактировать
                </Button>
                <Button
                    onClick={() => handleDelete(product._id)}
                    variant="danger"
                >
                    Удалить
                </Button>
            </div>
        )
    }));

    if (loading) return <div>Загрузка...</div>;
    if (error) return <div className="text-red-500">{error}</div>;

    return (
        <>
            <Table columns={columns} data={data} />

            <Modal
                isOpen={showEditModal}
                onClose={() => {
                    setShowEditModal(false);
                    setSelectedProduct(null);
                }}
                title="Редактирование продукта"
            >
                {selectedProduct && (
                    <ProductEditForm
                        product={selectedProduct}
                        onSuccess={() => {
                            setShowEditModal(false);
                            setSelectedProduct(null);
                            fetchProducts();
                        }}
                    />
                )}
            </Modal>
        </>
    );
};

export default ProductsList; 